module.exports = __webpack_public_path__ + "static/media/30.ec6c42a9.jpg";